import { axiosInstance } from "../../utils";

const actions = {
  FETCH_REPORTS_REQUESTED: "FETCH_REPORTS_REQUESTED",
  FETCH_REPORTS_SUCCEEDED: "FETCH_REPORTS_SUCCEEDED",
  FETCH_REPORTS_FAILED: "FETCH_REPORTS_FAILED",

  FETCH_PRODUCTS_REPORTS_REQUESTED: "FETCH_PRODUCTS_REPORTS_REQUESTED",
  FETCH_PRODUCTS_REPORTS_SUCCEEDED: "FETCH_PRODUCTS_REPORTS_SUCCEEDED",
  FETCH_PRODUCTS_REPORTS_FAILED: "FETCH_PRODUCTS_REPORTS_FAILED",

  DELETE_REPORT_REQUESTED: "DELETE_REPORT_REQUESTED",
  DELETE_REPORT_SUCCEEDED: "DELETE_REPORT_SUCCEEDED",
  DELETE_REPORT_FAILED: "DELETE_REPORT_FAILED",

  fetchReports: (params = undefined) => {
    return {
      type: actions.FETCH_REPORTS_REQUESTED,
      payload: params,
    };
  },
  fetchProductsReports: (params = undefined) => {
    return {
      type: actions.FETCH_PRODUCTS_REPORTS_REQUESTED,
      payload: params,
    };
  },

  removeReport: (params = undefined) => {
    return {
      type: actions.DELETE_REPORT_REQUESTED,
      payload: params,
    };
  },

  getReports: async (params = undefined) => {
    const url = `analytics/orders`;

    try {
      const reports = await axiosInstance.get(url, { params });
      return reports.data;
    } catch (error) {
      throw error;
    }
  },
  getProductsReports: async (params = undefined) => {
    const url = `analytics/products`;

    try {
      const reports = await axiosInstance.get(url, { params });
      return reports.data;
    } catch (error) {
      throw error;
    }
  },
  deleteReport: async (params = undefined) => {
    const url = `reports`;

    try {
      const reports = await axiosInstance.delete(url);
      return reports.data;
    } catch (error) {
      throw error;
    }
  },
};
export default actions;
